(() => {
  'use strict';

  const EVENT_PREFIX = 'ramservice:';

  const serviceFromPath = () => {
    const path = window.location.pathname.toLowerCase();

    if (path.includes('pulizia-ps5-metallo-liquido')) return 'ps5_metallo_liquido';
    if (path.includes('cambio-batteria')) return 'cambio_batteria';
    if (path.includes('schermo-display')) return 'riparazione_display';
    if (path.includes('connettore-ricarica')) return 'riparazione_ricarica';
    if (path.includes('offerte-sim-windtre-very-mobile')) return 'sim';
    if (path.includes('/pages/assistenza')) return 'assistenza';
    if (path.includes('/collections/apple-ricondizionati')) return 'apple_ricondizionati';
    if (path.includes('/collections/smartphone-nuovi')) return 'smartphone_nuovi';

    return 'generale';
  };

  const publish = (eventName, details = {}) => {
    const payload = {
      page_path: window.location.pathname,
      page_title: document.title,
      service_type: details.service_type || serviceFromPath(),
      cta_location: details.cta_location || 'unknown',
      ...details
    };

    if (!window.Shopify?.analytics?.publish) return false;

    try {
      window.Shopify.analytics.publish(`${EVENT_PREFIX}${eventName}`, payload);
      return true;
    } catch (error) {
      console.warn('RAMSERVICE analytics event non pubblicato', error);
      return false;
    }
  };

  window.RAMServiceConversionEvents = { publish, track: publish };

  const ctaLocation = (link) => {
    const labelledParent = link.closest('[data-cta-location]');
    return link.dataset.ctaLocation || labelledParent?.dataset.ctaLocation || 'sitewide';
  };

  const trackLink = (link) => {
    const href = link.getAttribute('href') || '';
    const details = { cta_location: ctaLocation(link) };
    const operator = link.closest('[data-ram-operator]')?.dataset.ramOperator;
    const offer = link.closest('[data-ram-offer-id]');
    if (operator === 'windtre' || operator === 'very') details.operator = operator;
    if (offer) details.offer_id = offer.dataset.ramOfferId.slice(0, 80);

    if (href.startsWith('tel:')) {
      publish('click_phone', details);
      return;
    }

    if (/wa\.me\//i.test(href)) {
      publish('click_whatsapp', details);
      return;
    }

    if (
      link.hasAttribute('data-ram-directions') ||
      /google\.(?:com|it)\/maps|maps\.app\.goo\.gl|maps\.google\./i.test(href)
    ) {
      publish('click_directions', details);
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (link) trackLink(link);
  }, { passive: true });

  document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('assistenza_posted') === 'true') {
      publish('repair_lead', {
        lead_type: 'repair',
        service_type: 'assistenza',
        cta_location: 'repair_contact_form_success'
      });
    }

    if (params.get('sim_posted') === 'true') {
      publish('sim_lead', {
        lead_type: 'sim',
        service_type: 'sim',
        cta_location: 'sim_contact_form_success'
      });
    }
  }, { once: true });
})();
